// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { doesNotHaveExpand } from "@insite/client-framework/Services/ApiService";
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import {
    chain,
    DispatchCompleteLoadWishLists,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { WishListCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<GetWishListsApiParameter, WishListCollectionModel>;

export const CustomDispatchCompleteLoadWishLists: HandlerType = props => {
    props.apiResult.wishListCollection?.forEach(wishList => {
        if (doesNotHaveExpand(props.apiParameter, "schedule")) {
            delete (wishList as Partial<typeof wishList>)?.["sendDayOfMonthPossibleValues"];
            delete (wishList as Partial<typeof wishList>)?.["sendDayOfWeekPossibleValues"];
        }
    });

    props.dispatch({
        type: "Data/WishLists/CompleteLoadWishLists",
        result: props.apiResult,
        parameter: props.parameter,
    });
};

replaceInChain(chain, DispatchCompleteLoadWishLists, CustomDispatchCompleteLoadWishLists);
